import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

type TCreateActivityComment = {
    activityId: string;
    commentId: string;
    params: {
        text: string;
    };
};

export default async ({
    activityId,
    commentId,
    params,
}: TCreateActivityComment) => {
    const tempHeaders = {
        auth: true,
    };

    const httpRequest = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/activity/${activityId}/comment/${commentId}`,
        method: "patch",
        body: params,
        headers: tempHeaders,
    });
    const { body, statusCode } = httpRequest;

    return handleStatusCases({ body, statusCode });
};
